import { token } from '@zenchef/styled-system/tokens'
import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

export const config = {
  brandName: publicRuntimeConfig.BRAND ?? 'zenchef',
  brandColor: token.var('colors.olive.700'),
  brandIcon: 'zenchef',
  brandFavicon: 'favicon.ico',
  brandWidgetUrl: 'bookings.zenchef.com',
  brandContactMail: 'help@zenchef.com',
  brandPrivacyMail: 'privacy@zenchef.com',
  brandAddress: '63 avenue de Villiers',
  brandZip: '75017',
  brandCity: 'Paris',
  brandRcsCity: 'Paris',
  brandRcsNumber: '528 389 794',
  brandCapital: '848,55'
}
